<template>
  <div class="box-label">
    <section class="canvas-section">
      <div class="tip-wrap">
        <p class="tip">{{ tip }}</p>
        <p>当前坐标 {{ curX }}，{{ curY }}</p>
        <p>当前缩放 {{ parseInt(scale * 100) }}%</p>
        <p>原始尺寸 {{ initialWidth }} × {{ initialHeight }}</p>
      </div>
      <div class="wrap" ref="wrap" :style="{height: wrapHeight + 'px'}">
        <canvas ref="canvasElem"
          :style="{
            width: width + 'px',
            height: height + 'px',
            transform: `scale(${scale}) translate(${transX}px, ${transY}px)`,
            cursor: canvasCursor
          }"></canvas>
      </div>
    </section>
    <div class="label-ctrl">
      <div class="btn-wrap">
        <!-- <a-button size="small" type="primary" @click="addPolygon"
          v-if="type==='polygon' && showDataSetBtn">新建polygon</a-button>
        <a-button size="small" type="primary" @click="addRect"
          v-if="type==='box' && showDataSetBtn">新增box</a-button> -->
        <a-button size="small" type="primary" @click="resetPosition">初始位置</a-button>
        <a-button v-if="showDataSetBtn && entities.length" size="small" type="primary" @click="save">保存</a-button>
      </div>
      <ul class="label-list" :style="{height: wrapHeight + 'px'}">
        <li
          class="label-item"
          v-for="(item, index) in entities"
          :key="index"
          :class="{
            'active': this.activeEntity === item
          }">
          <div class="label-info">
            <div class="checkbox"
              :class="{
                'is-checked': item.visible
              }"
              @click="setVisible(item)">
            </div>
            <div v-if="activeEntity === item && showDataSetBtn">
              <!-- <span style="color: #0C2366" @click="saveLabelChange(item)">保存</span> -->
              <span style="color: #0C2366" @click="cancelLabelChange(item)">OK</span>
              <span style="color: #ff4140" @click="deleteFromList(item)">删除</span>
            </div>
          </div>
          <div class="label-info" v-if="type === 'polygon'">
            <a-input v-if="activeEntity === item && showDataSetBtn" v-model:value="item.custom.label" placeholder="请输入名称" autocomplete="off"></a-input>
            <p @click="setActiveEntity(item)" v-else>{{ item.custom.label }}</p>
          </div>
          <div class="label-info" v-else-if="type === 'box'">
            <a-input v-if="activeEntity === item && showDataSetBtn" v-model:value="item.custom.name._text" placeholder="请输入名称" autocomplete="off"></a-input>
            <p @click="setActiveEntity(item)" v-else>{{ item.custom.name._text }}</p>
          </div>
          <div>
            <p class="point-data" v-if="item.entityType === 'polygon'">坐标：{{ JSON.stringify(item.points) }}</p>
            <p class="point-data" v-if="item.entityType === 'rect'">xmin：{{ item.xmin }} ymin：{{ item.ymin }} xmax：{{ item.xmax }} ymax：{{ item.ymax }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
/**
 * Readme
 * 从接口拿到字符串数据并解析，得到原始的json数据polygonData和objDetData，传到此组件中即为labelData
 *
 */
import { mapState } from 'vuex'
import CanLib from '@/CanLib/index'
import { addItemBoxLabel, updateItemBoxLabel, deleteItemBoxLabel } from '@/api/dataItem'
import { configConsumerProps } from 'ant-design-vue/lib/config-provider'
let bgImage = null // 背景图片类
const ctrlItems = [] // 被选中的覆盖物的顶点圆
const tempItems = [] // 绘制途中产生的临时点线
const rectVertexArr = [['xmin', 'ymin'], ['xmax', 'ymax']] // 矩形的控制点名称
let tempVertex = []
const size = 800
export default {
  props: {
    type: {
      type: String,
      default: 'box'
    },
    labelData: {
      type: Object,
      default: () => {}
    },
    currentDataItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      sandbox: null,
      axisHelper: null,
      transX: 0,
      transY: 0,
      beginMouseX: 0,
      beginMouseY: 0,
      beginTransX: 0,
      beginTransY: 0,
      scale: 1,
      initialScale: 1,
      initialWidth: 0,
      initialHeight: 0,
      width: size,
      height: size,
      wrapHeight: size,
      curX: 0,
      curY: 0,
      nameDic: {
        polygon: '多边形',
        rect: '矩形'
      },
      canvasCursor: 'default',
      entities: [], // 主要覆盖物
      newPoints: [], // 绘制过程的拾取点
      newEntity: null, // 当前绘制的覆盖物
      activeEntity: null, // 当前激活编辑的覆盖物
      status: 0,
      keyHandler: {}
    }
  },
  emits: ['save'],
  computed: {
    ...mapState(['appConfig', 'currentRole']),
    tip () {
      if (this.status === 0) {
        return '状态：空闲'
      } else if (this.status === 1) {
        return '画多边形：左键绘制多边形，右键回退，回车确认'
      } else if (this.status === 2) {
        return '画矩形：左键选择矩形的两个对角顶点'
      } else if (this.status === 3) {
        return '编辑：拖动顶点进行编辑'
      } else {
        return ''
      }
    },
    showDataSetBtn () {
      const invalid = ['9', '10', '11']
      return this.currentRole && invalid.indexOf(this.currentRole.roleId) === -1
    }
  },
  methods: {
    // 通用工具函数，增加键盘事件
    addKeyHandler (key, callback) {
      if (!this.keyHandler[key]) {
        this.keyHandler[key] = new Set()
      }
      this.keyHandler[key].add(callback)
    },
    // 通用工具函数，移除键盘事件
    removeKeyHandler (key, callback) {
      if (this.keyHandler[key]) {
        this.keyHandler[key].delete(callback)
      }
    },
    // 通用工具函数，键盘事件处理
    handleKey (e) {
      if (this.keyHandler[e.key]) {
        for (const callback of this.keyHandler[e.key].values()) {
          callback()
        }
      }
    },
    init () {
      this.initCanvas()
      this.initLabelData()
    },
    // 初始化
    initCanvas () {
      const img = this.appConfig.baseImgUrl + this.currentDataItem.accessSrc
      this.initBgImage(img)
      document.addEventListener('keyup', this.handleKey)
      this.sandbox = new CanLib.Sandbox(this.$refs.canvasElem, { width: size, height: size })
      this.axisHelper = new CanLib.AxisHelper({
        sandbox: this.sandbox,
        x: 0,
        y: 0,
        width: 1 / this.scale,
        color: '#fff'
      })
      this.sandbox.addAttachment(this.axisHelper)
      this.sandbox.on('mousemove', this.setCoord, {
        permeate: true
      })
      this.sandbox.on('mousemove', this.setCursorDefault)
      this.$refs.wrap.addEventListener('mousedown', this.dragOrNot) // 判断拖动
      this.$refs.wrap.addEventListener('mousewheel', this.handleWheel) // 滚轮缩放
    },
    setCoord (e) {
      this.curX = e[0]
      this.curY = e[1]
      this.axisHelper.x = e[0]
      this.axisHelper.y = e[1]
    },
    setCursorDefault (e) {
      this.canvasCursor = 'default'
    },
    // 拖动画布
    dragOrNot (e) {
      if ((this.status !== 0 && this.status !== 3) || this.activeCircle) return
      this.beginMouseX = e.clientX
      this.beginMouseY = e.clientY
      this.beginTransX = this.transX
      this.beginTransY = this.transY
      this.$refs.wrap.addEventListener('mousemove', this.moveCanvas)
      this.$refs.wrap.addEventListener('mouseup', this.stopMoveCanvas)
      this.$refs.wrap.addEventListener('mouseleave', this.stopMoveCanvas)
    },
    moveCanvas (e) {
      if (this.activeCircle) return
      const diffX = (e.clientX - this.beginMouseX) / this.scale
      const diffY = (e.clientY - this.beginMouseY) / this.scale
      this.transX = this.beginTransX + diffX
      this.transY = this.beginTransY + diffY
    },
    stopMoveCanvas () {
      this.$refs.wrap.removeEventListener('mousemove', this.moveCanvas)
      this.$refs.wrap.removeEventListener('mouseup', this.stopMoveCanvas)
      this.$refs.wrap.removeEventListener('mouseleave', this.stopMoveCanvas)
    },
    handleWheel (e) {
      const scaleStep = 0.1
      e.preventDefault()
      const delta = e.wheelDelta
      if (delta > 0) {
        const scale = this.scale + scaleStep
        if (scale < this.initialScale * 10) {
          this.scale = scale
        } else {
          this.scale = this.initialScale * 10
        }
      } else if (delta < 0 && this.scale > this.initialScale) {
        const scale = this.scale - scaleStep
        if (scale > this.initialScale) {
          this.scale = scale
        } else {
          this.scale = this.initialScale
        }
      }
      [...tempItems, ...ctrlItems].forEach(c => {
        c.radius = 6 / this.scale
      })
      this.axisHelper.width = 1 / this.scale
    },

    // 画背景图
    initBgImage (src) {
      return new Promise((resolve, reject) => {
        const image = document.createElement('img')
        image.onload = () => {
          if (image.width === 0 || image.height === 0) {
            reject(new Error('图片加载失败'))
          }
          this.width = image.width
          this.height = image.height
          this.initialWidth = image.width
          this.initialHeight = image.height
          this.sandbox.width = this.width
          this.$refs.canvasElem.width = this.width
          this.sandbox.height = this.height
          this.$refs.canvasElem.height = this.height
          this.wrapHeight = size / this.width * this.height
          this.scale = size / this.width
          this.axisHelper.width = 1 / this.scale
          this.initialScale = this.scale
          this.$nextTick(() => {
            bgImage = new CanLib.Background({ sandbox: this.sandbox, x: 0, y: 0, width: this.width, height: this.height, image })
            this.sandbox.add(bgImage)
            resolve()
          })
        }
        image.onerror = reject
        image.src = src
      })
    },
    // 重置缩放位置
    resetPosition () {
      this.transX = 0
      this.transY = 0
      this.scale = this.initialScale
    },
    async initLabelData () {
      this.clearLabelData()
      this.initExistEntities()
    },
    clearLabelData () {
      this.entities.forEach(et => {
        et.destruct()
      })
      this.entities.length = 0
    },
    initExistEntities () {
      console.log(this.labelData)
      let raw = {}
      try {
        raw = JSON.parse(JSON.stringify(this.labelData))
      } catch {
        return
      }
      if (this.type === 'polygon' && raw.shapes) {
        const data = raw.shapes
        if (Array.isArray(data)) {
          data.forEach(item => {
            this.polygonProcess(item)
          })
        } else if (Object.prototype.toString.call(data) === '[object Object]') {
          this.polygonProcess(data)
        }
      } else if (this.type === 'box' && raw.annotation && raw.annotation.object) {
        const data = raw.annotation.object
        if (Array.isArray(data)) {
          data.forEach(item => {
            this.objectProcess(item)
          })
        } else if (Object.prototype.toString.call(data) === '[object Object]') {
          this.objectProcess(data)
        }
      }
    },
    polygonProcess (item) {
      const et = this.drawPolygon({
        color: 'rgba(100, 155, 255, .7)',
        points: item.points,
        shape_type:item.shape_type
      })
      et.custom = {
        ...item
      }
      et.on('mousemove', this.setCursorPointer)
      this.entities.push(et)
      et.on('click', e => {
        this.setActiveEntity(et)
      })
    },
    objectProcess (item) {
      const xy = item.bndbox
      if (xy.xmin && xy.ymin && xy.xmax && xy.ymax) {
        const et = this.drawRect({
          color: 'rgba(100, 205, 110, .7)',
          xmin: xy.xmin._text - 0,
          xmax: xy.xmax._text - 0,
          ymin: xy.ymin._text - 0,
          ymax: xy.ymax._text - 0
        })
        et.custom = {
          ...item
        }
        et.on('mousemove', this.setCursorPointer)
        this.entities.push(et)
        et.on('click', e => {
          this.setActiveEntity(et)
        })
      }
    },
    // 显示隐藏
    setVisible (et) {
      et.visible = !et.visible
      if (!et.visible) {
        this.exitEditing()
      }
    },
    setCursorPointer () {
      this.canvasCursor = 'pointer'
    },
    setCursorMove () {
      this.canvasCursor = 'move'
    },
    // 新建多边形部分
    // 暂时停用，开始新建多边形
    addPolygon () {
      if (this.status !== 0) return
      this.status = 1
      this.newPoints = []
      this.sandbox.on('click', this.pickPolygon, {
        permeate: true
      })
      this.sandbox.on('contextmenu', this.backstep)
      this.addKeyHandler('Enter', this.completePolygon)
    },
    // 暂时停用 左键拾取顶点
    pickPolygon (e) {
      this.newPoints.push(e)
      const vertex = new CanLib.Circle({
        sandbox: this.sandbox,
        x: e[0],
        y: e[1],
        radius: 6 / this.scale,
        color: '#0C2366'
      })
      this.sandbox.add(vertex)
      tempItems.push(vertex)
      if (this.newPoints.length === 2) {
        tempVertex = [...e]
        this.sandbox.on('mousemove', this.mousemovePolygon, {
          permeate: true
        })
        this.newEntity = this.drawPolygon({
          color: 'rgba(100, 155, 255, .7)',
          points: [...this.newPoints, tempVertex]
        })
      } else if (this.newPoints.length > 3 && this.newEntity) {
        this.newEntity.points = [...this.newPoints, tempVertex]
      }
    },
    // 暂时停用
    mousemovePolygon (e) {
      tempVertex = [...e]
      this.newEntity.points = [...this.newPoints, tempVertex]
    },
    // 暂时停用 右键回退
    backstep () {
      if (this.newPoints.length) {
        this.newPoints.pop()
        const vertex = tempItems.pop()
        this.sandbox.remove(vertex)
        if (this.newEntity) {
          if (this.newPoints.length >= 2) {
            this.newEntity.points = [...this.newPoints, tempVertex]
          } else {
            this.newEntity.destruct()
            this.newEntity = null
            this.sandbox.off('mousemove', this.mousemovePolygon)
          }
        }
      }
    },
    // 暂时停用 创建多边形
    drawPolygon (params) {
      const polygon = new CanLib.Polygon({
        sandbox: this.sandbox,
        points: params.points,
        color: params.color,
        shape_type:params.shape_type
      })
      this.sandbox.add(polygon)
      return polygon
    },
    // 暂时停用 回车键 完成新建
    completePolygon (e) {
      this.sandbox.off('mousemove', this.mousemovePolygon)
      this.sandbox.off('click', this.pickPolygon)
      this.sandbox.off('contextmenu', this.backstep)
      this.newEntity.points = [...this.newPoints]
      this.newPoints = []
      tempItems.forEach(v => {
        this.sandbox.remove(v)
      })
      tempItems.length = 0
      const et = this.newEntity
      et.on('mousemove', this.setCursorPointer)
      this.entities.push(et)
      et.on('click', e => {
        this.setActiveEntity(et)
      })
      this.newEntity = null
      this.removeKeyHandler('Enter', this.completePolygon)
      this.status = 0
      addItemBoxLabel({
        itemId: this.currentDataItem.id,
        polygonJson: JSON.stringify(et.points)
      }).then(res => {
        this.exitEditing()
        this.initLabelData()
      })
    },

    // 新建矩形部分
    // 暂时停用，开始新建矩形
    addRect () {
      if (this.status !== 0) return
      this.status = 2
      this.newPoints = []
      this.sandbox.on('mousedown', this.startRect)
    },
    // 暂时停用
    startRect (e) {
      this.newPoints = [e]
      const vertex = new CanLib.Circle({
        sandbox: this.sandbox,
        x: e[0],
        y: e[1],
        radius: 6 / this.scale,
        color: '#0C2366'
      })
      this.sandbox.add(vertex)
      tempItems.push(vertex)
      this.sandbox.on('mousemove', this.moveRect, {
        permeate: true
      })
      this.sandbox.on('mouseup', this.endRect, {
        permeate: true
      })
    },
    // 暂时停用
    moveRect (e) {
      this.newPoints[1] = e
      if (this.newPoints[0][0] === e[0] || this.newPoints[0][1] === e[1]) return
      const x1 = this.newPoints[0][0]
      const y1 = this.newPoints[0][1]
      const x2 = this.newPoints[1][0]
      const y2 = this.newPoints[1][1]
      const xmin = x1 < x2 ? x1 : x2
      const xmax = x1 < x2 ? x2 : x1
      const ymin = y1 < y2 ? y1 : y2
      const ymax = y1 < y2 ? y2 : y1
      if (!this.newEntity) {
        this.newEntity = this.drawRect({
          color: 'rgba(100, 205, 110, .7)',
          xmin,
          xmax,
          ymin,
          ymax
        })
      } else {
        this.newEntity.xmin = xmin
        this.newEntity.xmax = xmax
        this.newEntity.ymin = ymin
        this.newEntity.ymax = ymax
      }
    },
    // 暂时停用
    endRect (e) {
      this.sandbox.off('mousedown', this.startRect)
      this.sandbox.off('mousemove', this.moveRect)
      this.sandbox.off('mouseup', this.endRect)
      const et = this.newEntity
      et.on('mousemove', this.setCursorPointer)
      this.entities.push(et)
      this.newEntity = null
      this.newPoints = []
      tempItems.forEach(v => {
        this.sandbox.remove(v)
      })
      tempItems.length = 0
      this.status = 0
      addItemBoxLabel({
        itemId: this.currentDataItem.id,
        xmin: et.xmin,
        ymin: et.ymin,
        xmax: et.xmax,
        ymax: et.ymax
      }).then(res => {
        this.exitEditing()
        this.initLabelData()
      })
      setTimeout(() => {
        if (et) {
          et.on('click', e => {
            this.setActiveEntity(et)
          })
        }
      }, 0)
    },
    // 暂时停用
    drawRect (params) {
      const rect = new CanLib.Rect({
        sandbox: this.sandbox,
        xmin: params.xmin,
        ymin: params.ymin,
        xmax: params.xmax,
        ymax: params.ymax,
        color: params.color
      })
      this.sandbox.add(rect)
      return rect
    },
    // 覆盖物编辑部分
    // 点击一个覆盖物，激活编辑状态
    setActiveEntity (et) {
      if (this.status !== 0) return
      this.status = 3
      this.activeEntity = et
      this.clearCtrlItems()
      if (et.entityType === 'polygon') {
        et.points.forEach((pos, index) => {
          const circle = new CanLib.Circle({
            sandbox: this.sandbox,
            x: pos[0],
            y: pos[1],
            radius: 6 / this.scale,
            color: '#0C2366'
          })
          circle.vertexIndex = index
          this.sandbox.add(circle)
          circle.on('mousemove', this.setCursorMove)
          ctrlItems.push(circle)
          circle.on('mousedown', e => {
            if (!this.showDataSetBtn) return
            this.activeCircle = circle
            this.sandbox.on('mousemove', this.moveCircle, {
              permeate: true
            })
            this.sandbox.on('mouseup', this.circleMouseup)
          })
        })
      } else if (et.entityType === 'rect') {
        rectVertexArr.forEach((nameArr, index) => {
          const circle = new CanLib.Circle({
            sandbox: this.sandbox,
            x: et[nameArr[0]],
            y: et[nameArr[1]],
            radius: 6 / this.scale,
            color: '#0C2366'
          })
          circle.vertexIndex = index
          this.sandbox.add(circle)
          circle.on('mousemove', this.setCursorMove)
          ctrlItems.push(circle)
          circle.on('mousedown', e => {
            if (!this.showDataSetBtn) return
            this.activeCircle = circle
            this.sandbox.on('mousemove', this.moveCircleOfRect, {
              permeate: true
            })
            this.sandbox.on('mouseup', this.circleMouseupRect)
          })
        })
      }
    },
    // 退出编辑
    exitEditing () {
      this.status = 0
      this.activeEntity = null
      this.clearCtrlItems()
    },
    // 删除一个覆盖物，暂时停用
    deleteFromList (item) {
      debugger
      const i = this.entities.indexOf(item)
      if (i === -1) return
      this.entities.splice(i, 1)
      item.destruct()
      this.exitEditing()
     
      //this.initLabelData()
      // deleteItemBoxLabel(item.custom.id).then(res => {
      //   this.exitEditing()
      //   this.initLabelData()
      // })
    },
    // 多边形，拖拽顶点
    moveCircle (e) {
      const pos = this.activeEntity.points[this.activeCircle.vertexIndex]
      pos[0] = e[0]
      pos[1] = e[1]
      this.activeCircle.x = pos[0]
      this.activeCircle.y = pos[1]
    },
    // 多边形，松起鼠标结束拖拽
    circleMouseup () {
      this.sandbox.off('mousemove', this.moveCircle)
      this.sandbox.off('mouseup', this.circleMouseup)
      this.activeCircle = null
    },
    // 矩形，拖拽顶点
    moveCircleOfRect (e) {
      const nameArr = rectVertexArr[this.activeCircle.vertexIndex]
      this.activeEntity[nameArr[0]] = e[0]
      this.activeEntity[nameArr[1]] = e[1]
      this.activeCircle.x = e[0]
      this.activeCircle.y = e[1]
    },
    // 矩形，松起鼠标结束拖拽
    circleMouseupRect () {
      this.sandbox.off('mousemove', this.moveCircleOfRect)
      this.sandbox.off('mouseup', this.circleMouseupRect)
      this.activeCircle = null
    },
    // 清除编辑覆盖物的控制点
    clearCtrlItems () {
      ctrlItems.forEach(c => {
        this.sandbox.remove(c)
      })
      ctrlItems.length = 0
    },
    // 原接口保存名称编辑，暂时停用
    saveLabelChange (item) {
      const params = {
        id: item.custom.id,
        name: item.custom.name
      }
      if (item.entityType === 'polygon') {
        params.polygonJson = JSON.stringify(item.points)
      } else if (item.entityType === 'rect') {
        params.xmin = item.xmin
        params.ymin = item.ymin
        params.xmax = item.xmax
        params.ymax = item.ymax
      }
      updateItemBoxLabel(params).then(res => {
        this.exitEditing()
        this.$message.success('修改成功')
        this.initLabelData()
      })
    },
    // 停止编辑
    cancelLabelChange (item) {
      this.exitEditing()
    },
    save () {
      this.exitEditing()
      const raw = JSON.parse(JSON.stringify(this.labelData))
      if (this.type === 'polygon') {
        const result = this.entities.map(et => {
          return {
            ...et.custom,
            points: et.points
          }
        })
        raw.shapes = result
      } else if (this.type === 'box') {
        const result = this.entities.map(et => {
          return {
            ...et.custom,
            bndbox: {
              xmin: { _text: et.xmin },
              ymin: { _text: et.ymin },
              xmax: { _text: et.xmax },
              ymax: { _text: et.ymax }
            }
          }
        })
        raw.annotation.object = result
      }
      this.$emit('save', raw)
    },
    leave () {
      this.resetPosition()
      this.clearLabelData()
      document.removeEventListener('keyup', this.handleKey)
      if (this.$refs.wrap) {
        this.$refs.wrap.removeEventListener('mousedown', this.dragOrNot) // 判断拖动
        this.$refs.wrap.removeEventListener('mousewheel', this.handleWheel) // 滚轮缩放
      }
      if (this.sandbox) this.sandbox.destruct()
      this.sandbox = null
    }
  }
}
</script>
<style lang="less">
.box-label {
  display: flex;
  --size: 800px;
  .canvas-section {
    width: calc(var(--size) + 2px);
    .tip-wrap {
      display: flex; justify-content: flex-end;
      height: 40px; line-height: 40px;
      p {
        margin-left: 40px;
      }
      .tip {
        margin-left: 0;
        margin-right: auto;
        color: #3333ff;
        font-weight: bold;
        text-align: left;
      }
    }
    .wrap {
      display: block;
      width: var(--size);
      overflow: hidden;
      display: flex; justify-content: center; align-items: center;
      canvas {
        display: block;
      }
    }
  }
  .label-ctrl {
    width: calc(100% - var(--size) - 2px);
    padding: 0 10px; box-sizing: border-box;
    .btn-wrap {
      height: 40px; display: flex; align-items: center;
      .ant-btn {
        margin-right: 5px;
      }
    }
    .label-list {
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 10px;
        background: #f3f6fc;
      }
      &::-webkit-scrollbar-thumb {
        // background: green;
        background: #eaeaea;
      }
      .label-item {
        margin: 0 0 5px;
        border: 2px solid #e2e2e2;
        padding: 5px;
        box-sizing: border-box;
        &.active {
          border-color: #0C2366;
        }
      }
    }
    .label-info {
      height: 20px;
      display: flex; justify-content: space-between;
      span {
        margin-left: 15px;
        cursor: pointer;
      }
      .ant-input {
        width: 100px;
      }
      .checkbox {
        margin-right: 14px;
        position: relative;
        width: 14px; height: 14px;
        border: 1px solid #e2e2e2;
        box-sizing: content-box;
        border-radius: 2px;
        cursor: pointer;
        &.is-checked::after {
          content: '';
          position: absolute; top: 2px; left: 2px;
          width: 10px; height: 10px;
          background: green;
        }
      }
    }
    .point-data {
      width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
  }
}
</style>
